const defaultState = {
    loading: false,
    loaded: false,
    data: null,
    error: null
};

const CurrentUserReducer = (state = defaultState, action) => {
    switch (action.type) {
        case "SET_CURRENT_USER_LOADING":
            return {
                ...state,
                loading: true,
                error: null
            };
            
        case "SET_CURRENT_USER":
            return {
                ...state,
                loading: false,
                loaded: true,
                data: action.payload,
                error: null
            };
            
        case "SET_CURRENT_USER_ERROR":
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.payload
            };
            
        case "CLEAR_CURRENT_USER":
            return defaultState;
            
        default:
            return state;
    }
};

export default CurrentUserReducer;